import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { debounce } from 'throttle-debounce'
import BattleLogEntry from './BattleLogEntry'

const BattleLog = ({ eventLog }) => {
    const [scrollMaxed, setScrollMaxed] = useState(true)
    const chatLogDOMNode = useRef(null)

    const getCurrentScroll = () => {
        const chatLog = chatLogDOMNode.current
        const { scrollHeight, clientHeight, scrollTop } = chatLog

        return {
            chatLog,
            scrollHeight,
            height: clientHeight,
            scrollTop,
            maxScrollTop: scrollHeight - clientHeight,
        }
    }

    const scrollToBottom = () => {
        const { chatLog, maxScrollTop } = getCurrentScroll()

        if (scrollMaxed) {
            chatLog.scrollTop = maxScrollTop > 0 ? maxScrollTop : 0
        }
    }

    useEffect(() => {
        scrollToBottom()
    })

    const isScrolledToMax = () => {
        const { scrollTop, maxScrollTop } = getCurrentScroll()
        return scrollTop === maxScrollTop
    }

    const updateScrolledToMax = () => {
        if (chatLogDOMNode.current) { setScrollMaxed(isScrolledToMax()) }
    }

    const debouncedUserScroll = debounce(200, () => { updateScrolledToMax() })

    const handleUserScroll = () => {
        debouncedUserScroll()
    }

    return (
        <div className="battleLog">
            <h5 className="battleLog__label">Battle Log:</h5>
            <div
                className="battleLog__display"
                ref={chatLogDOMNode}
                onScroll={handleUserScroll}
            >
                {
                    eventLog.map(entry => <BattleLogEntry key={entry.logID} entry={entry} />)
                }
            </div>
        </div>
    )
}

BattleLog.propTypes = {
    eventLog: PropTypes.array.isRequired,
}

export default BattleLog
